import React, { Component } from "react";
import {
  Input,
  InputLabel,
  InputAdornment,
  FormControl,
  IconButton,
  Button,
  Icon
} from "@material-ui/core";
import URL from "../constants/url";
import { auth } from "../firebase";
const axios = require("axios");

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value
});

const INITIAL_STATE = {
  passwordOne: "",
  passwordTwo: "",
  error: null
};

class PasswordChangeForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };

    if (this.state.status == "Success!") console.log("sss");
  }

  onSubmit = event => {
    const { passwordOne } = this.state;

    auth
      .doPasswordUpdate(passwordOne)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
        this.setState(byPropKey("status", "Success!"));
        axios.post(URL + "/updateuser/changed", {
          uid: this.props.uid,
          pass: passwordOne
        });
      })
      .catch(error => {
        this.setState(byPropKey("error", error));
      });

    event.preventDefault();
  };

  render() {
    const { passwordOne, passwordTwo, error } = this.state;

    // it validates the state before submitting a request to change the password by enabling or disabling the submit button.
    const isInvalid = passwordOne !== passwordTwo || passwordOne === "";

    return (
      <div>
        <div id="passwordChange" className="baslik">
          <i className="material-icons">fingerprint</i>
          <h4>Change Password</h4>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", marginLeft: "10px" }}>
          <FormControl className="passwdBox">
            <InputLabel htmlFor="adornment-password">New Password</InputLabel>
            <Input
              id="adornment-password"
              type="password"
              value={passwordOne}
              onChange={event => {
                this.setState(byPropKey("passwordOne", event.target.value));
              }}
            />
          </FormControl>
          <FormControl className="passwdBox">
            <InputLabel htmlFor="adornment-passwordTwo">
              Confirm New Password
            </InputLabel>
            <Input
              id="adornment-passwordTwo"
              type="password"
              value={passwordTwo}
              onChange={event => {
                this.setState(byPropKey("passwordTwo", event.target.value));
              }}
            />
          </FormControl>
          <Button
            variant="contained"
            color="primary"
            disabled={isInvalid}
            onClick={this.onSubmit}
          >
            Change Password
          </Button>
          {error && (
            <p style={{ margin: "auto 20px", color: "#d50000" }}>
              {error.message}
            </p>
          )}
          {this.state.status && (
            <p style={{ margin: "auto 20px", color: "purple" }}>
              {this.state.status}
            </p>
          )}
        </div>
        {/*<form onSubmit={this.onSubmit}>
          <input
            value={passwordOne}
            // The component updates its local state by using onChange handlers in the input fields.
            onChange={event =>
              this.setState(byPropKey("passwordOne", event.target.value))
            }
            type="password"
            placeholder="New Password"
          />
          <br />
          <input
            value={passwordTwo}
            onChange={event =>
              this.setState(byPropKey("passwordTwo", event.target.value))
            }
            type="password"
            placeholder="Confirm New Password"
          />
          <br />
          <button disabled={isInvalid} type="submit">
            Reset My Password
          </button>
          {error && <p>{error.message}</p>}
          </form>*/}
      </div>
    );
  }
}

export default PasswordChangeForm;
